import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AdminSMSView from '../components/views/admin/AdminSMSView';
import { SkeletonAdminBody } from '../components/Skeleton';

function AdminSMSPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const res = await api.get('/auth/me');
        // /auth/me returns the user object directly, not wrapped in { user: ... }
        const raw = res?.data;
        const userData = raw && raw.user ? raw.user : raw;

        if (!userData || !userData._id) {
          navigate('/login');
          return;
        }

        // Check if user is admin
        if (userData.role !== 'A') {
          navigate('/dashboard');
          return;
        }

        // Check if user is locked
        if (userData.locked) {
          navigate('/locked');
          return;
        }

        setUser(userData);
      } catch (error) {
        console.error('Error fetching user:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-50">
        <SkeletonAdminBody form />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <AdminSMSView user={user} />;
}

export default AdminSMSPage;

